<template>
    <div class="page-container">
      <div class="flex-between top">
        <div></div>
        <div class="top-icons">
          <img :src="logo" alt="logo">
          <el-popover
            placement="top-start"
            title=""
            
            trigger="hover"
            >
        <div class="flex-column-space-between ">
          <p class="password cp" @click="changePassword">修改密码<i class="el-icon-caret-right"></i></p>
          <p class="password cp"  style="margin-top: 20px;"@click="changeInfor">编辑资料<i class="el-icon-caret-right"></i></p>
           <p class="password cp" @click="quit" style="margin-top: 20px;">退出登录<i class="el-icon-caret-right"></i></p>
        </div>
    <img :src="av" alt="头像" slot="reference">
  </el-popover>
        </div>
      </div>
      <div class="main-content"> 
        <p class="usermanage">用户管理</p>
        
        <div style="width: 100%;margin-top: 2%;margin-bottom: 1%;display: flex;position: relative;">

            <el-form :model="setDeviceForm"  ref="setDeviceForm" label-width="60px"  style="display: flex;">
              <el-form-item label="学院：" >
                       <el-select v-model="setDeviceForm.userDepartment" placeholder="请选择"  class="college-select" @change="handleChange">
                                <el-option
                                    v-for="item in Data"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                       </el-select>
                       
             </el-form-item>
             <el-form-item label="角色："  >
                                <el-select v-model="setDeviceForm.userRole" placeholder="请选择"  class="college-select" @change="handleChange1">
                                <el-option
                                    v-for="item in Data1"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                                </el-select>
                 </el-form-item>
                <el-form-item label="专业："  v-if="setDeviceForm.userRole =='学生'||'家长'">
                                <el-select v-model="setDeviceForm.career" placeholder="请选择" class="college-select" @change="handleChange2">
                                <el-option
                                    v-for="item in Data2"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                                </el-select>
                 </el-form-item>
                  <el-form-item label="年级："  v-if="setDeviceForm.userRole =='学生'||'家长'">
                                <el-select v-model="setDeviceForm.grade" placeholder="请选择"  class="college-select" @change="handleChange3">
                                <el-option
                                    v-for="item in Data3"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                                </el-select>
                 </el-form-item>

          </el-form>

        <div style="position: absolute;right: 0;">
            <input type="text" v-model="input" placeholder="请输入学号/工号" class="search-input">
            <el-button @click="searchs" type="primary" icon="el-icon-search" style="box-sizing: border-box;height: 40px;" ></el-button>
        </div>
        </div>
        
       <LeaderForm v-if="setDeviceForm.userRole =='领导'" :formdata="formdata" @refresh-data="feData"></LeaderForm>
       <TeacherForm v-if="setDeviceForm.userRole =='教师'" :formdata="formdata" @refresh-data="feData" ></TeacherForm>
      <PreceptorForm v-if="setDeviceForm.userRole =='辅导员'" :formdata="formdata" @refresh-data="feData"></PreceptorForm>
      <StudentForm v-if="setDeviceForm.userRole =='学生'" :formdata="formdata" @refresh-data="feData" ></StudentForm>
      <OtherForm v-if="setDeviceForm.userRole =='家长'" :formdata="formdata" @refresh-data="feData" ></OtherForm>
      <ParentsForm v-if="setDeviceForm.userRole =='管理员'" :formdata="formdata" @refresh-data="feData"></ParentsForm>
      <StuTeacherForm v-if="setDeviceForm.userRole =='学生骨干'" :formdata="formdata" @refresh-data="feData"></StuTeacherForm>
      </div>
        <div class="flex-between" style="margin-top: 1%;">
        <el-button type="primary" class="upload" @click="upload()"><i class="el-icon-download" >上传</i></el-button>

           
      </div>
          <!-- 修改密码 -->
    <el-dialog 
  :visible.sync="dialogVisible" 
  width="25%"
  custom-class="custom-dialog"
>
  <div style="display: flex;">
    <Password @custom-event="handleDataFromChild"></Password>
  </div>
</el-dialog>
<!-- 编辑资料 -->
<el-dialog 
  :visible.sync="dialogVisible1" 
  width="25%"
  custom-class="custom-dialog"
>
  <div style="display: flex;">
    <Information @custom-info="handleDataFromInfo" :inform = "inform"></Information>
  </div>
</el-dialog>

<el-dialog 
  :visible.sync="dialogVisible2" 
  width="25%"
  custom-class="custom-dialog"
>
  <div style="width: 100%;">
       <div>
        <p class="upload1">上传用户信息</p>
       <p @click="download" style="text-decoration: underline; cursor: pointer;">点击此处下载模版</p>
    <!-- Element UI 上传组件 -->
    <el-upload
      :action="`${this.$config.API_BASE_URL}/hz-university-pc/file/upload_file`"  
      ref="upload"
      :auto-upload="false"  
      :on-change="handleFileChange"  
      :show-file-list="false"  
      accept=".xlsx, .xls"
      style="text-align: center;"  
    >
      <el-button type="primary" >选择Excel文件</el-button>
    </el-upload>


    <!-- 显示选中的文件带关闭图标 -->
    <div v-if="file" class="file-display" style="text-align: center;" >
      <span class="file-name">{{ file.name }}</span>
      <i class="el-icon-close close-icon" @click="removeFile" style="font-size: 20px;"></i>
      <el-button 
        @click="uploadFile" 
        type="success" 
        size="small"
        class="upload-btn"
      >
        上传
      </el-button>
    </div>
  </div>
  </div>
</el-dialog>

    </div>
  </template>
  
  <script>
import Password from '@/components/Password/Password.vue'
import Information from '@/components/Information/Information.vue'
import LeaderForm from './compontents/LeaderForm.vue'
import TeacherForm from './compontents/TeacherForm.vue'
import PreceptorForm from './compontents/PreceptorForm.vue'
import StudentForm from './compontents/StudentForm.vue'
import ParentsForm from './compontents/ParentsForm.vue'
import OtherForm from './compontents/OtherForm.vue'
import StuTeacherForm from './compontents/StuTeacherForm.vue'
  export default {
    components: {
        Password,
        Information,
        LeaderForm,
        TeacherForm,
        PreceptorForm,
        StudentForm,
        ParentsForm,
        OtherForm,
        StuTeacherForm
    },
    data() {
      return {
         file: null,  // 存储选中的文件
        dialogVisible:false,
        dialogVisible1:false,
        dialogVisible2:false,
        inform:{},
        setDeviceForm:{
          userDepartment:'',
          userRole:'',
          career:'',
          grade:''
        },
        input:'',
        fileList: [],
        av: require('@/assets/pic/avatar.png'),
        logo: require('@/assets/pic/logo.png'),
      Data:[],
      Data1:[],
      Data2:[],
      Data3:[],
        formdata:[],
      }
      
    },
    watch:{

    },
    mounted(){

      this.init()
    },
    methods: {
     async searchs(){
        console.log(this.input,'searchssearchs')
        const Informations = {
          userDepartment:this.setDeviceForm.userDepartment,
          userRole:this.setDeviceForm.userRole,
          studentNumber:this.input

        }
              try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.post(
                    `${this.$config.API_BASE_URL}/hz-university-pc/user/queryUserList`, Informations,{ headers}
                  );
                  
                  if (res.data.code === 200) {
               this.formdata = res.data.data
                console.log(this.formdata, 'this.formdata');

                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
      },
      handleChange(newValue){
    console.log("选中的值:", newValue);
    // 你可以在这里根据新选择的值做其他操作
    this.setDeviceForm.userDepartment = newValue
    this.feData()
      },
  handleChange1(newValue1) {
    console.log("选中的值:", newValue1);
    // 你可以在这里根据新选择的值做其他操作
    this.setDeviceForm.userRole = newValue1
    this.feData()
  },
   handleChange2(newValue2) {
    console.log("选中的值:", newValue2);
    // 你可以在这里根据新选择的值做其他操作
    this.setDeviceForm.career = newValue2
    this.feData()
  },
  handleChange3(newValue3) {
    console.log("选中的值:", newValue3);
    // 你可以在这里根据新选择的值做其他操作
    this.setDeviceForm.grade = newValue3
    this.feData()
  },
      init(){
       const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const userDepartment = {}
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/getEnumsList`, userDepartment, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
              this.Data = data.data || [];
              this.setDeviceForm.userDepartment = this.Data[0]||null
              console.log(this.Data,'this.Data')
              this.role()
							this.$message({
								message: data.msg,
								type: 'success'
						});

						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
      },
    role(){
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const formList = {
        userDepartment:this.setDeviceForm.userDepartment,
      }
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/getEnumsList`, formList, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
               this.Data1 = data.data || [];
               this.setDeviceForm.userRole = this.Data1[0]||null
              console.log(this.Data1,'this.Data1')
              this.career()
							this.$message({
								message: data.msg,
								type: 'success'
						});

						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
      },
      career(){
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const formList = {
        userDepartment:this.setDeviceForm.userDepartment,
        userRole:this.setDeviceForm.userRole,
      }
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/getEnumsList`, formList, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
               this.Data2 = data.data || [];
               this.setDeviceForm.career = this.Data2[0]||null
              console.log(this.Data2,'this.Data2')
                this.grade()   
							this.$message({
								message: data.msg,
								type: 'success'
						});

						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
      },
      grade(){
        const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const formList = {
        userDepartment:this.setDeviceForm.userDepartment,
        userRole:this.setDeviceForm.userRole,
        career:this.setDeviceForm.career
      }
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/getEnumsList`, formList, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
               this.Data3 = data.data || [];
                this.setDeviceForm.grade = this.Data3[0]||null
              console.log(this.Data3,'this.Data3')
              this.feData()
							this.$message({
								message: data.msg,
								type: 'success'
						});

						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
      },
    feData(){
         const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const formList = {
        userDepartment:this.setDeviceForm.userDepartment,
        userRole:this.setDeviceForm.userRole,

      }
        // 只有当角色不是"学生"或"家长"时，才添加 career 和 grade 字段
  if (['学生','家长'].includes(this.setDeviceForm.userRole)) {
    formList.career = this.setDeviceForm.career;
    formList.grade = this.setDeviceForm.grade;
  }

       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/queryUserList`, formList, { headers }).then((resp) =>{
              let data = resp.data;

              if(data.code =='200'){
                 this.formdata = data.data
                console.log(this.formdata, 'this.formdata');
               
							this.$message({
								message: data.msg,
								type: 'success'
						});

						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
    },
 
      download(){
          // 直接通过浏览器打开文件链接（自动下载）
          const link = document.createElement('a');
          link.href = '/templates/用户信息导入.xlsx'; // 对应 public 下的路径
          link.download = '用户信息导入.xlsx'; // 下载时的文件名
          link.click();
      },
        changePassword(){
      this.dialogVisible = true
    },
        changeInfor(){
          this.dialogVisible1 = true
          const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/getOneUser`,  { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
                this.inform = data.data
							this.$message({
								message: data.msg,
								type: 'success'
						});
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
        },
        upload(){
          this.dialogVisible2 = true
        },
        //修改密码
      handleDataFromChild(data) {
      console.log("父组件收到数据:", data); 
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/updateUserPassWord`, data, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
             this.dialogVisible = false
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
    },
    handleDataFromInfo(data){
            console.log("父组件收到数据:", data); 
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const mailbox = data.email;
      const datainfo = {
        mailbox:mailbox,
        phone:data.phone

      }

       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/updateUser`, datainfo, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
						this.dialogVisible1 = false
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
   
    },
        quit(){
                  const headers = {
                'satoken': localStorage.getItem('token'),
              };
              this.$confirm('此操作退出登录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/logout`,{ headers }).then((resp) => {
            let data = resp.data;
            if(data.code == '200') {       						
                this.$router.push({path:'/'})
                 localStorage.clear();
       this.$message({
                type: 'success',
                message: '退出登录成功!'
              });
            } else {
              this.$message.error(data.msg);
            }
          }); 
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消退出登录'
              });          
            });
        },
       // 文件选择时触发
    handleFileChange(file) {
      const isExcel =
        file.raw.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.raw.type === "application/vnd.ms-excel";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isExcel) {
        this.$message.error("只能上传 .xlsx 或 .xls 文件！");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("文件大小不能超过 5MB！");
        return false;
      }

      // 验证通过，存储文件
      this.file = file.raw;
    },
    removeFile() {
      this.file = null;
      this.clearFiles();
    },
    
    clearFiles() {
      this.$refs.upload.clearFiles();
    },
        // 手动上传文件
    // uploadFile() {
    //   if (!this.file) {
    //     this.$message.warning("请先选择文件！");
    //     return;
    //   }
    //   const formData = new FormData();
    //   formData.append("file", this.file);

    //   // 发送到后端
    //   this.$http.post('https://university.service.hzyichuan.cn/hz-university-pc/user/information/import', formData, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //       'satoken': localStorage.getItem('token'),
    //     },
    //   })
    //   .then((res) => {
    //     this.$message.success("上传成功！");
    //     this.removeFile()
    //     this.dialogVisible2 = false
    //     console.log("服务器返回:", res.data);
    //   })
    //   .catch((err) => {
    //     this.$message.error("上传失败！");
    //     console.error("错误:", err);
    //   });
    // }
    // 手动上传文件
uploadFile() {
  if (!this.file) {
    this.$message.warning("请先选择文件！");
    return;
  }

  const formData = new FormData();
  formData.append("file", this.file);

  // 发送到后端
  this.$http.post('https://saas.elecstudy.com/hz-university-pc/user/information/import', formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      'satoken': localStorage.getItem('token'),
    },
  })
  .then((res) => {
    if (res.data.code === 200) {  
      this.$message.success("上传成功！");
      this.removeFile();
      this.dialogVisible2 = false;
      console.log("服务器返回:", res.data);
    } else {
      this.$message.error(`上传失败: ${res.data.msg || '未知错误'}`);
    }
  })
  .catch((error) => {
    this.$message.error(`上传失败！错误: ${res.data.msg || '未知错误'}`);
    console.error("错误:", error);
  });
}
  
      }
  }
  </script>
  
  <style scoped>
  .upload1{

font-size: 30px;
font-weight: 700;
letter-spacing: 0px;
line-height: 43.44px;
color: rgba(0, 0, 0, 1);
text-align: left;


  }
  .search-input{

width: 280px;
height: 40px;
opacity: 1;
border-radius: 6px;
background: rgba(255, 255, 255, 1);
padding-left: 20px;
margin-right: 20px;

border: 1px solid rgba(209, 220, 240, 1);


  }
  .usermanage{

font-size: 30px;
font-weight: 700;
letter-spacing: 0px;
line-height: 43.44px;
color: rgba(0, 0, 0, 1);

  }
.password{

width: 150px;
height: 35px;
opacity: 1;
border-radius: 15px;
border: 1px solid rgba(39, 154, 255, 1);
margin: auto;

font-size: 20px;
font-weight: 500;
letter-spacing: 0px;
line-height: 28.96px;
color: rgba(130, 127, 127, 1);
text-align: center;
}
/* 使用深度选择器穿透scoped样式 */
::v-deep .custom-dialog {
  border-radius: 30px;
  background: #fff;
  border: 2px solid #fff;
  overflow: hidden;
}
::v-deep .custom-dialog .el-dialog__header,
::v-deep .custom-dialog .el-dialog__body {
  background: transparent;
}
.el-table .cell {
  height: 35px;
}
  /* 基础布局设置 */
  .page-container {
    background-image: url('../../assets/pic/background.png');
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    padding: 0 2%;
    display: flex;
    flex-direction: column;
  }

  /* 顶部栏样式 */
  .top {
  width: 100%;
  padding-top: 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  }
  .college-select {
  width: 150px;
  margin-left: 1%;
  margin-right: 1%;
  /* height: 35px; */
  }
  .top-icons img {
    width: 3.5vw;
    height: 3.5vw;
    max-width: 55px;
    max-height: 55px;
    min-width: 30px;
    min-height: 30px;
    margin-left: 1vw;
  }
  
  .college-select {
    width: 12vw;
    min-width: 180px;
    max-width: 220px;
  }
  

  

  /* 主要内容区域 */
  .main-content {
  width: 100%;

  height: 77vh; /* 设置高度为 70vh */
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);
  padding: 2%;
  display: flex;
  flex-direction: column; /* 垂直排列 */
  overflow: hidden;
  position: relative; /* 设为相对定位，使弹出框相对于这个容器定位 */
  margin-top: 3.5%;
}

.detail-box {
  position: absolute; /* 使用绝对定位 */
  top: 0; /* 设置弹出框顶部与 main-content 顶部对齐 */
  right: 0; /* 设置弹出框右侧与 main-content 右侧对齐 */
  width:450px; /* 设置弹出框宽度 */
  height: 100%; /* 高度设为与 main-content 相同 */
  background: rgba(255, 255, 255, 0.9); /* 背景色 */
  box-shadow: -2px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 10; /* 确保弹出框在表格上层 */
  overflow-y: auto; /* 如果内容超出，允许滚动 */
}

.box-content {
  flex: 1;
  overflow-y: auto; /* 使得内容区域支持滚动 */
}

.el-button {
  margin-top: 10px;
}

 .upload{
    width: 100px;
    height: 40px;
    border-radius: 10px;

background: rgba(0, 129, 255, 1);
 }
 .butview{
width: 80px;
height: 30px;
opacity: 1;
border-radius: 50px;
background: rgba(39, 154, 255, 0.2);
font-size: 12px;
letter-spacing: 0px;
line-height: 8px;
color: rgba(39, 154, 255, 1);

 }
  /* 响应式调整 */
  @media (max-width: 992px) {
    .content-wrapper {
      flex-direction: column;
    }
    

  }
  
  @media (max-width: 768px) {
    .top {
      flex-direction: column;
      gap: 2vh;
    }
    
    .top-icons {
      order: -1;
    }
    

  }
  </style>